import { render, staticRenderFns } from "./PopupTextSubHeading.vue?vue&type=template&id=79acd40c&scoped=true"
import script from "./PopupTextSubHeading.vue?vue&type=script&lang=js"
export * from "./PopupTextSubHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79acd40c",
  null
  
)

export default component.exports